// extracted by mini-css-extract-plugin
module.exports = {"root":"TargetAssetCard_root__t4nQM","tabs":"TargetAssetCard_tabs__B4iKx","tabItem":"TargetAssetCard_tabItem__CxyWP","gsiLoader":"TargetAssetCard_gsiLoader___kjvl"};